import { initDependencies, setupDependencies } from './dependencies';
import '../node/assets/images/cian-logo-cyrillic-vertical.png';

setupDependencies();
initDependencies();

/* Импорт должен следовать строго после инициализации зависимостей, иначе возникнут ошибки сборки картинок.
Поскольку для корректного формиривания урла картинок должна вызваться функция setupWebpackPublicPath из @cian/web */
require('./addform/scripts/addform-app');
